import api from 'api';

export const DESIGN_LAYOUTS_ASYNC_ACTION_START = 'DESIGN_LAYOUTS_ASYNC_ACTION_START';
export const DESIGN_LAYOUTS_ASYNC_ACTION_ERROR = 'DESIGN_LAYOUTS_ASYNC_ACTION_ERROR';
export const DESIGN_LAYOUTS_ASYNC_ACTION_SUCCESS = 'DESIGN_LAYOUTS_ASYNC_ACTION_SUCCESS';
export const DESIGN_LAYOUTS_ASYNC_CHANGE_ACTION_SUCCESS = 'DESIGN_LAYOUTS_ASYNC_CHANGE_ACTION_SUCCESS';
export const DESIGN_LAYOUTS_RESET_STATE = 'DESIGN_LAYOUTS_RESET_STATE';

function designLayoutsAsyncActionStart() {
  return {
    type: DESIGN_LAYOUTS_ASYNC_ACTION_START,
  };
}

function designLayoutsAsyncActionError(error) {
  return {
    type: DESIGN_LAYOUTS_ASYNC_ACTION_ERROR,
    error,
  };
}

function designLayoutsAsyncActionSuccess(data) {
  return {
    type: DESIGN_LAYOUTS_ASYNC_ACTION_SUCCESS,
    data,
  };
}

function designLayoutsChangeAsyncActionSuccess() {
  return {
    type: DESIGN_LAYOUTS_ASYNC_CHANGE_ACTION_SUCCESS,
  }
}

export function resetDesignLayoutsState() {
  return {
    type: DESIGN_LAYOUTS_RESET_STATE,
  }
}

export function getDesignLayoutsAsync(typeId, sizeId, designTextVer) {
  return (dispatch, getState) => {
    dispatch(designLayoutsAsyncActionStart());
    return api.request(`designLayout/list?typeId=${typeId}&sizeId=${sizeId}&designTextVer=${designTextVer}`, 'get')
    .then((data) => {
      dispatch(designLayoutsAsyncActionSuccess(data));
      return data;
    })
    .catch((error) => {
      dispatch(designLayoutsAsyncActionError('Unable to get design layouts'));
      throw error;
    });
  };
}

export function changeDesignLayoutAsync(design) {
  return (dispatch, getState) => {
    dispatch(designLayoutsAsyncActionStart());
    return api.request(`design/changeLayout`, 'put', design)
    .then((data) => {
      dispatch(designLayoutsChangeAsyncActionSuccess());
      return data;
    })
    .catch((error) => {
      dispatch(designLayoutsAsyncActionError('Unable to change design layouts'));
      throw error;
    });
  };
}
